import { render, staticRenderFns } from "./EntireBag.vue?vue&type=template&id=f2dae8f6&scoped=true&"
import script from "./EntireBag.vue?vue&type=script&lang=js&"
export * from "./EntireBag.vue?vue&type=script&lang=js&"
import style0 from "./EntireBag.vue?vue&type=style&index=0&id=f2dae8f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2dae8f6",
  null
  
)

export default component.exports